import { registerLocaleData } from '@angular/common';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localeNlBeExtra from '@angular/common/locales/extra/nl-BE';
import localeNl from '@angular/common/locales/nl';
import localeNlBe from '@angular/common/locales/nl-BE';
import { inject, Injector, Service } from '@angular/core';
import { Router, Routes } from '@angular/router';

import { BaasI18n, LOCALE } from '@lvflanders/bar';

import { baasCoreContext } from '../baas-core.context';
import { BAAS_CORE_I18N } from '../baas-core.i18n';
import { createPageNotFoundRoute } from '../functions';
import { BarEmptyComponent } from '../pages/bar-empty.component';

const CORE_ROUTES: Routes = [{ path: 'bar-refresh', component: BarEmptyComponent, data: { _framework: true } }, createPageNotFoundRoute('**')];

@Service()
export class BaasCoreInitService {
    readonly #injector = inject(Injector);
    readonly #router = inject(Router);
    readonly #i18n = inject(BaasI18n);

    init(): void {
        baasCoreContext.injector = this.#injector;
        // register nl-BE
        registerLocaleData(localeNlBe, LOCALE.FLEMISH, localeNlBeExtra);
        registerLocaleData(localeNl, LOCALE.DUTCH, localeNlExtra);
        // set up translation system
        this.#i18n.addTranslations('DOMAIN_BAAS_CORE', BAAS_CORE_I18N);
        this.#router.config.push(...CORE_ROUTES);
    }
}
